angular.module 'zc.projects'

.directive 'projectSearch', (Project) ->
  directive =
    restrict: "EA"
    scope: {
      onSelect: "&"
    }
    replace: true
    templateUrl: '/templates/projects/views/directives/project_search.html'
    link: (scope, element) ->
      scope.Project = Project
      scope.projects = []
      
      Project.all().then (projects) ->
        scope.projects = _.map(projects, (p) -> {id: p.id, apikey: p.apikey, title: p.title, company_name: p.company_name})
        
      scope.selectProject = (item, model, label) ->
        scope.onSelect({project: model})
        # this empties the input field
        @selectedProject = ""


  directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/project_search.coffee